var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page_home_news col-lg-8 mb-8" },
    [
      _c(
        "v-carousel",
        { attrs: { "hide-delimiters": "", height: "auto" } },
        _vm._l(_vm.carousel, function (img, i) {
          return _c("v-carousel-item", { key: i, attrs: { src: img.src } })
        }),
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("v-pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.news[0],
            expression: "news[0]",
          },
        ],
        attrs: { length: _vm.news.length },
        model: {
          value: _vm.page,
          callback: function ($$v) {
            _vm.page = $$v
          },
          expression: "page",
        },
      }),
      _vm._v(" "),
      _c("table", { staticClass: "table table-responsive" }, [
        _c(
          "tbody",
          _vm._l(_vm.news[_vm.page - 1], function (item) {
            return _c("tr", { key: item.title }, [
              _c("th", { attrs: { scope: "row" } }, [
                _c("h4", [
                  item.announcer == "ceec"
                    ? _c("span", { staticClass: "badge badge-primary" }, [
                        _vm._v("大考中心"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.announcer == "cac"
                    ? _c("span", { staticClass: "badge badge-info" }, [
                        _vm._v("甄委會"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.announcer == "uac"
                    ? _c("span", { staticClass: "badge badge-warning" }, [
                        _vm._v("考分會"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.announcer == "jbcrc"
                    ? _c("span", { staticClass: "badge badge-success" }, [
                        _vm._v("招聯會"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.announcer == "cape"
                    ? _c("span", { staticClass: "badge badge-secondary" }, [
                        _vm._v("術聯會"),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _vm._l(item.type, function (type, index) {
                    return _c(
                      "v-chip",
                      {
                        key: index,
                        attrs: {
                          small: "",
                          "text-color": "white",
                          color: "primary",
                        },
                      },
                      [_vm._v(_vm._s(type))]
                    )
                  }),
                  _vm._v(" "),
                  item.type[0] ? _c("br") : _vm._e(),
                  _vm._v(" "),
                  _vm._l(item.titles, function (t) {
                    return _c(
                      "a",
                      {
                        key: t.title,
                        attrs: {
                          href: t.link == "" ? null : t.link,
                          target: "_blank",
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(t.title) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("td", { staticClass: "time" }, [
                _vm._v(_vm._s(item.date.slice(0, 10))),
              ]),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "card mb-4" }, [
        _c("div", { staticClass: "card-body reminder" }, [
          _c("h2", { staticClass: "card-title" }, [_vm._v("重要提醒")]),
          _vm._v(" "),
          _c("p", { staticClass: "card-text" }, [_c("NoteItem")], 1),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "mt-4 mb-3" }, [
      _vm._v("最新消息\n        "),
      _c("small", [_vm._v("News")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }